import { render, staticRenderFns } from "./block-acquiring-payment-link.vue?vue&type=template&id=4fce276a&scoped=true&lang=pug&"
import script from "./block-acquiring-payment-link.vue?vue&type=script&lang=js&"
export * from "./block-acquiring-payment-link.vue?vue&type=script&lang=js&"
import style0 from "./block-acquiring-payment-link.vue?vue&type=style&index=0&id=4fce276a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce276a",
  null
  
)

export default component.exports